import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";

const FacilityWebSiteSchema = ({ baseUrl }) => {
	const rootUrl = baseUrl || "https://www.storage.com";

	const webSiteSchema = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		"@id": `${rootUrl}/#website`,
		name: "Storage.com",
		url: `${rootUrl}/`,
		potentialAction: {
			"@type": "SearchAction",
			target: `${rootUrl}/search?location={search_term_string}`,
			"query-input": "required name=search_term_string"
		},
		sameAs: [
			"https://www.facebook.com/SelfStorageMarketplace/",
			"https://www.twitter.com/storagecom",
			"https://www.linkedin.com/company/storage-com"
		]
	};

	return <Schema schema={webSiteSchema} />;
};

FacilityWebSiteSchema.propTypes = {
	baseUrl: PropTypes.string.isRequired
};

export default FacilityWebSiteSchema;
